<template>
  <div>
    <Header :breadcrumsfirst="breadcrumsfirst" :breadcrumslast="breadcrumslast" />
    <alarmTabs />
    <div class="container mb-1">
      <div class="row px-3 py-3 d-flex justify-content-start">
        <div class="col-md-2-5">
          <div class="form-group">
            <label for="startDate" class="custom-label">Start Date</label>
            <input id="startDate" type="date" class="form-control shadow-none form-select-sm custom-input">
          </div>
        </div>
        <div class="col-md-2-5">
          <div class="form-group">
            <label for="endDate" class="custom-label">End Date</label>
            <input id="endDate" type="date" class="form-control shadow-none form-select-sm custom-input">
          </div>
        </div>
      </div>

    </div>
   
    <div class="container">
    <div class="row px-3 py-2">
      <div class="col-md-12">
        <table class="table table-responsive table-bordered custom-label">
        <thead class="table-light main-table">
          <tr>
            <th scope="col" width="15" class="no-border"></th>
            <th scope="col" colspan="4" width="300">Title / ID <br>Desc, Note</th>
            <th scope="col" class="align-middle" width="400">Sensor Tile</th>
            <th scope="col" class="align-middle">Timestamp</th>
            <th scope="col" class="align-middle no-border" >Severity / Status</th>
            <th scope="col" width="15"></th>
          </tr>
        </thead>
        <tbody v-for="(item, index) in tableData" :key="index">
          <tr>
            <td rowspan="4" ><span class="d-flex justify-content-center align-items-center"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-grid" viewBox="0 0 16 16">
  <path d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5zM2.5 2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5zm6.5.5A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5zM1 10.5A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5zm6.5.5A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5z"/>
</svg></span></td>
            <td colspan="4"> <label class=" mb-0">{{ item.title }}</label>
              <span class=" mb-0">(id)</span>
            </td>
            <td colspan="1">Sensor</td>
            <td><span class=" mb-0">Date, time</span></td>
            <td>
              <span class="severity">01</span>
              <span class="severity-status">Pending</span>
            </td>
            <td  rowspan="3" class="align-middle">
              <span class="d-flex justify-content-center align-items-center">
                <button class="custom-dropdown-icon" @click="toggleCollapse(index)">
  <svg v-if="isCollapsed[index]"
  xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
       class="bi bi-chevron-down" viewBox="0 0 16 16">
    <path fill-rule="evenodd"
          d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/>
  </svg>
  <svg v-else
  xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
       class="bi bi-chevron-right" viewBox="0 0 16 16">
    <path fill-rule="evenodd"
          d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"


 />
  </svg>
</button>

              </span>
            </td>

          </tr>
          <tr>
            <td colspan="7">
              <p class="text-xs text-textPrimary4 mb-0 text-ellips-one">Description</p>
            </td>
            <!-- <td  rowspan="3">
              <span class="d-flex justify-content-end">
                <button class="custom-dropdown-icon" @click="toggleCollapse(index)"><svg
                    xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-chevron-down" viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                      d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                  </svg></button>
              </span>
            </td> -->
          </tr>
          <tr>
            <td colspan="7">
              <p class="text-xs text-textPrimary4 mb-0">Note</p>
            </td>

          </tr>
          <tr v-if="isCollapsed[index]">
            <td colspan="9" class="py-0 px-0">
              <table class="table table-responsive sub-table mb-0">
                <thead class="table-light">
                  <tr>
                    <th scope="col" width="120">Status Reason</th>
                    <th scope="col" width="100">Device</th>
                    <th scope="col" width="120">Sensor Type</th>
                    <th scope="col" width="90">Hub</th>
                    <th scope="col" width="90">Physical ID</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>test</td>
                    <td>test</td>
                    <td>test</td>
                    <td>test</td>
                    <td>test</td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>


      </table>
      </div>
     
    </div>
</div>


  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import alarmTabs from '@/components/alarm-tabs.vue';
export default {
  name: 'reports',
  components: {
    Header,
    alarmTabs
  },
  data() {
    return {
      breadcrumsfirst: "Dashboard",
      breadcrumslast: "Alarms",
      tableData: [
        {
          id: 1,
          title: "title"
        },

      ],
      isCollapsed: [],
      currentPage: 1,
      pageSize: 5,
      totalCount: 0,
      pageSizeOptions: [5, 10, 20],
    }
  },
  created() {
    // Initialize isCollapsed with the correct length and set all elements to false
    this.isCollapsed = new Array(this.tableData.length).fill(false);
  },
  methods: {
    toggleCollapse(index) {
      this.isCollapsed[index] = !this.isCollapsed[index];
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalCount / this.pageSize);
    },
    visiblePages() {
      const totalVisiblePages = 3; // Change this as needed
      const pages = [];
      let startPage = 1;
      let endPage = this.totalPages;

      if (this.totalPages > totalVisiblePages) {
        const halfVisiblePages = Math.floor(totalVisiblePages / 2);
        startPage = Math.max(this.currentPage - halfVisiblePages, 1);
        endPage = startPage + totalVisiblePages - 1;

        if (endPage > this.totalPages) {
          startPage -= endPage - this.totalPages;
          endPage = this.totalPages;
        }

        if (startPage > 1) {
          pages.push(1);
          if (startPage > 2) {
            pages.push('dots');
          }
        }
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      if (endPage < this.totalPages) {
        if (endPage < this.totalPages - 1) {
          pages.push('dots');
        }
        pages.push(this.totalPages);
      }

      return pages;
    }
  },


}
</script>

<style scoped>
.col-md-2-5 {
  flex: 0 0 20%;
  /* 20% of the container width */
  max-width: 20%;
}

.sub-table {
  border: transparent;
}

.custom-dropdown-icon {
  border: none;
  /* Remove the border */
  background: none;
  /* Remove background */
  cursor: pointer;
  /* Change cursor to pointer on hover */
  padding: 0;
  /* Remove padding */
  margin: 0;
  /* Remove margin */
}
.severity{
  border: 1px solid #1371E7;
  background-color: #1371E7;
  color: white;
  font-weight: 600;
  border-radius: 5px;
 padding: 2px;
 margin-right: 5px;
  
}
.severity-status{
border: 1.5px solid rgb(248, 187, 67);
background-color: transparent;
  color:  rgb(248, 187, 67);
  font-weight: 600;
  border-radius: 5px;
 padding: 2px;
 text-transform: uppercase;
}

.table th {
  background-color: #f1f2f4;
}
.main-table th{
  padding-top: 3px;
  padding-bottom: 3px;

}

.no-border {
    border-right: 1px solid transparent;
  }

</style>